// removed by extract-text-webpack-plugin
module.exports = {"view-tab":"_2AKw","view-list":"_169p","view-item":"_3O4v","active":"_1tax"};


//////////////////
// WEBPACK FOOTER
// ./checkout/components/redirection/style.css
// module id = GAtr
// module chunks = 4